<template>
    <div id="sidebar-container" class="column left hide-scrollbar" :class="{ 'collapsed': !displayed, [$mq]: $mq }">

        <template v-if="displayed">
            <div class="stock-container">
                <!-- <div class="calendar-navigation-container">
                    <calendar-navigation @select="selectDate" @calendarOpen="calendarState"
                        :selected_date="selected_date" :future_days="1" :past_days="1"></calendar-navigation>
                </div> -->
                <div class="date">
                    <i class="i-andy-calendar i-andy-xs"></i>
                    <span class="day">
                        {{ formatMainDate(date, 'dddd') }}
                        |
                    </span>
                    <span class="full-day">
                        {{ formatMainDate(date, 'DD/MM/YY') }}
                    </span>
                </div>

                <template>
                <div class="title-column">
                    <div class="title">
                        <p><i class="i-andy-ticket i-andy-xs"></i>{{ $t('production.plk.sidebar.title') }}</p>
                    </div>
                </div>
                <div class="stock-list">
                    <div class="product" v-for="product in stock" :key="product.id" :class="{ 'negative': product.units <= 0 }" v-if="stock.length > 0" @click="editProduct(product)">
                        <span class="name">{{ product.name }}</span>
                        <div class="units-container">
                            <div class="units">
                                <span>{{ product.units }}</span>
                                <span><!-- {{ product.unitName }} -->uds</span>
                            </div>
                            <i class="i-andy-delete i-andy-m" :class="{ 'disabled': product.units <= 0 }"></i>
                        </div>
                    </div>
                </div>
            </template>
            </div>
            <template v-if="expanded">
                <div id="summary" v-if="summary">
                    <SalesSummary :summary="summary"></SalesSummary>

                    <div class="action-buttons">
                        <button class="toggle" @click="toggle()"></button>
                        <button class="btn search" @click="updateOption()">
                            {{ $t('production.configuration.button') }}
                        </button>
                    </div>

                </div>
            </template>
        </template>

        <template v-else>
            <div id="summary">
                <div class="action-buttons">
                    <button class="toggle collapse" @click="toggle()"></button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CalendarNavigation from '@/components/layout/CalendarNavigation.vue'
import SalesSummary from '@/components/domain/sales/salesSummary.vue'

export default {
    name: 'Sidebar',
    props: {
        categories: { type: Object },
        date: { type: String },
        summary: { type: Object },
        expanded: { type: Boolean },
        selected: { type: Boolean },
        reset: { type: Boolean },
        displayed: { type: Boolean },
        stock: { type: Array, default: () => [] }
    },
    components: {
        CalendarNavigation,
        SalesSummary
    },
    data() {
        return {
            selected_date: this.date,
            categorySelected: false,
            calendarIsVisible: false
        }
    },
    computed: {
        sortedCategories() {
            return Object.values(this.categories).sort((a, b) => parseInt(a.order) - parseInt(b.order))
        },
        category() {
            return this.$store.getters['production/getSelectedCategory']
        }
    },
    methods: {
        selectCategory(category) {
            this.categorySelected = category
        },
        formatDate(date) {
            const momentDate = moment(date) || date
            if(momentDate.isValid()) {
                return momentDate.format('dddd DD')
            } else {
                return date
            }
        },
        selectDate(date) {
            this.$emit('selectDate', date)
        },
        calendarState(show) {
            this.calendarIsVisible = show
        },
        editProduct(product) {
            if(product.units <= 0) {
                return
            }
            this.$emit('selectMermaProduct', product)
        },
        clickCat(category) {
            var container = document.getElementsByClassName('categories-container')[0]
            if (container) container.scrollTop = 0

            if (category !== 'allCategories') {
                this.allCategories = false
                this.catSelPortrait = false
                if (this.cantSelectCategoryPrinterError) {
                    return false
                } else {
                    if (this.activePredef) {
                        this.activePredef = false
                        this.selectedLab = {}
                    }
                    if (!this.holdingCat) {
                        this.$store.commit('production/selectCategory', category)
                    } else {
                        this.holdingCat = false
                    }
                    this.stateSelected = false
                }
            } else {
                this.allCategories = true
                this.catSelPortrait = true
            }

            this.debounceSearchInput = ''
            this.searchInput = ''
        },
        updateOption() {
            this.$store.commit('production/setConfiguration', true)
        },
        resetForecast() {
            let self = this

            this.$popup.delete({
                message: self.$t('production.reset.title'), // ¿Quieres eliminar la guía de condimentos actual y volver a generar la proyección seleccionando días de referencia distintos?
                textSave: self.$t('production.reset.yes'), // Sí, eliminar
                textCancel: self.$t('popup.delete.text_cancel'),
                callSave: function () {
                    self.$overlay.loading()
                    self.$store.dispatch('production/resetForecast', self.date).then(() => {
                        self.$store.dispatch('production/loadForecast', self.date).then(() => {
                            self.$popup.close()
                            self.$overlay.hide()
                        })
                    })
                }
            })
        },
        formatMainDate(date, format) {
            return moment(date).format(format)
        },
        formatDate(date) {
            if (this.isValidDate(date)) {
                return moment(date).locale(localStorage.language).format('dddd').toUpperCase() + ' ' + moment(date).format('DD/MM')
            } else {
                const localWeekdays = moment.weekdays()
                const englishWeekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
                const weekdayIndex = englishWeekdays.indexOf(date)
                return localWeekdays[weekdayIndex].toUpperCase()
            }
        },
        isValidDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD', true).isValid()
        },
        toggle() {
            this.$emit('toggle')
        }
    },
    created() { },
    watch: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#sidebar-container {
    padding: 8px;
    height: 100%;
    position: relative;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;

    $size-bolita: rem(18px);

    &.collapsed {
        justify-content: flex-end;
    }

    .stock-container {
        width: 100%;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        flex-direction: column;
        max-height: 65vh;
        .date {
            @include font-size(14px);
            font-family: $text-bold;
            color: $color-black;
            text-transform: uppercase;
            text-align: left;
            width: 100%;
            padding: 8px;
            border-radius: 8px;
            background-color: $color-secondary-100;
            margin: 8px;
            @include display-flex();
            @include align-items(center);
            @include justify-content(flex-start);
            gap: 4px;
            .day {
                font-family: $text-bold;
                color: $color-black;
                text-transform: uppercase;
                font-weight: bold;
            }
            .full-day {
                font-family: $text;
                color: $color-black;
                text-transform: uppercase;
            }
        }

        .stock-list {
            height: 100%;
            @include display-flex();
            @include align-items(center);
            @include justify-content(flex-start);
            @include flex-direction(column);
            padding: 8px;
            width: 100%;
            gap: 8px;
            overflow: auto;

            .product {
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                gap: 8px;
                width: 100%;
                padding-bottom: 8px;
                border-bottom: 1px solid $color-neutral-200;

                &.negative {
                    .units {
                        border: 2px solid $color-error-100;
                        background-color: $color-error-100;
                        >span:first-child {
                            color: $color-error-800;
                        }
                    }


                }

                .name {
                    overflow: hidden;
                    color: $color-black;
                    text-overflow: ellipsis;
                    font-family: $text-bold;
                    @include font-size(14px);
                    text-transform: uppercase;
                    @include display-flex();
                    @include align-items(center);
                    max-height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
                .units-container {
                    @include display-flex();
                    @include align-items(center);
                    @include justify-content(center);
                    @include flex-direction(row);
                    gap: 8px;
                }

                .units {
                    @include display-flex();
                    @include flex-direction(row);
                    @include align-items(center);
                    @include justify-content(center);
                    gap: 4px;
                    padding: 8px 4px;
                    min-width: 120px;
                    border-radius: 4px;
                    border: 2px solid $color-neutral-200;
                    background-color: $color-neutral-50;

                    >span {
                        @include font-size(16px);
                        font-family: $text-bold;
                        color: $color-black;
                        text-align: center;
                        line-height: 1;
                    }

                    >span:last-child {
                        @include font-size(14px);
                        font-family: $text;
                        color: $color-neutral-600;
                        text-align: center;
                    }
                }

                i[class^="i-andy-delete"]{
                    color: $color-neutral-500;
                    &.disabled {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }

    

    .title-column {
        width: 100%;
        @include display-flex();
        @include align-items(flex-start);
        @include justify-content(center);
        padding: 8px;
        .title {
            padding: 8px;
            width: 100%;
            background-color: $color-neutral-200;
            border-radius: 8px;

            p {
                padding: unset;
                width: 100%;
                @include font-size(14px);
                color: $color-neutral-600;
                text-transform: uppercase;
                font-family: $text;
                text-align: left;
            }
        }
    }

    .column.categories {
        width: 100% !important;
        border-radius: 5px;
        margin: 16px 0;
        max-height: calc(100% - 50px - 30%);
        overflow: auto;
        height: 70%;

        .tab {
            @include font-size(sm);
            color: #888;
            font-family: $text;
            text-align: center;
            margin: 0 auto 0 auto;
            padding: 12px 6px;
            width: 50%;
            height: 40px;
            display: inline-block;

            &.selected {
                color: $main-text;
                border-bottom: 2px solid $main-light;
            }
        }

        .item {
            @include interaction();
            @include display-flex();
            @include align-items();
            @include justify-content(space-between);
            @include font-size(m);
            line-height: 1;
            color: #555;
            min-height: rem(45px);
            padding: 4px 8px;
            margin: 4px 0;
            border-radius: 5px;
            // background-color: #fff;

            .color {
                width: $size-bolita;
                height: $size-bolita;
                border-radius: 100%;
            }

            .text,
            .count {
                display: inline-block;
                font: inherit;
                @include font-size(sm);
                font-family: $text;
                line-height: inherit;
                white-space: break-spaces;
                word-break: break-word;
            }

            .text {
                width: calc(100% - #{$size-bolita + rem(10px)});
            }

            .count {
                @include background($color: $main-t80);
                @include border-radius(20px);
                @include font-size(s);
                font-family: $text;
                line-height: 20px;
                min-width: 20px;
                width: auto;
                height: 20px;
                text-align: center;
                padding: 0px 4px;
            }

            @include bgHover($inactive-t90);

            &.selected {
                background-color: $main;

                .text {
                    color: white;
                    font-family: $text-bold;
                }

                .color {
                    filter: brightness(75%);
                }

                @include bgHover($main);
            }

            &.all {}

            &:active {
                animation-name: itemHoldCat;
                animation-duration: 125ms;
                animation-delay: 175ms;
                animation-iteration-count: 1;
                animation-fill-mode: forwards;
            }

            @include keyframes(itemHoldCat) {
                100% {
                    background-color: #f9f9f9;
                    border-left-color: $accent-dark;
                }
            }
        }

        .collection {
            @include interaction();
            @include display-flex();
            @include align-items();
            @include justify-content(space-between);
            @include font-size(m);
            line-height: 1;
            color: #555;
            min-height: rem(60px);
            padding: 4px 12px;
            margin: 4px;
            border-radius: 5px;

            @include bgHover($inactive-t90);

            &.selected {
                font-family: $text-bold;
                background-color: $main;
                color: #fff;

                @include bgHover($main);
            }
        }
    }

    #summary {
        width: 100%;
        bottom: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .row {
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items: center;
            justify-content: space-between;
            gap: 25px;
            flex-wrap: nowrap;
            word-break: break-word;
            width: 100%;
            padding: 4px 0;
            @include font-size(xs);
            line-height: 100%;

            .value {
                font-family: $text-bold;
                width: 35%;
                text-align: right;
                @include font-size(xs);

                &.update {
                    font-family: $text;
                }
            }

            &.level {
                margin-top: 8px;

                .value {
                    padding: 4px 8px;
                    border-radius: 3px;
                    background-color: $color-warning-500;
                }
            }

            &.current {
                margin-top: 0px;

                .value {
                    padding: 4px 8px;
                    border-radius: 3px;
                    color: #fff;
                    width: auto;
                    min-width: 90px;
                    text-align: center;

                    &.positive {
                        background-color: $color-success-500;
                    }

                    &.negative {
                        background-color: $color-error-500;
                    }

                    &.neutral {
                        background-color: $color-neutral-500;
                    }
                }
            }
        }

        .reset {
            text-decoration: underline;
            color: $main;
            font-family: $text-bold;
            cursor: pointer;
            padding: 16px 0;
            @include font-size(s);
        }

        .action-buttons {
            display: flex;
            flex-direction: row;
            gap: 8px;
            width: 100%;

            .toggle {
                width: 50px;
                height: 45px;
                @include background($image: img('left_main.svg'), $position: center center, $size: 20px, $color: $main-t70);
                border-radius: 4px;

                &.collapse {
                    @include background($image: img('right_main.svg'), $position: center center, $size: 20px, $color: $main-t70);
                }

            }

            .btn {
                width: 100%;
                background-color: $main-t70;
                color: $color-black;
                font-family: $text;
            }


        }
    }

    /* PLS SIZES MONITORS*/
    &.landscape {
        .stock-container{
            .stock-list{
                .product{
                    .name{
                        @include font-size(14px);
                    }
                    .units{
                        min-width: 80px;

                        >span:first-child{
                            @include font-size(16px);
                        }
                        >span:last-child{
                            @include font-size(14px);
                        }
                    }
                    .units-container {
                        i[class^="i-andy-delete"]{
                            font-size: 24px;
                        }
                    }
                }
            }
        }
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss" scoped></style>
